export default {
  filename: '',
  description: 'min:1|max:255'
}
